import * as React from "react";

export const CurrentEmailContext = React.createContext(null);
